import React from 'react';
import './point.scss';

const Point = ({ adress}) => {

    return (
        <div className="f-mark-point"  >

                <div className="f-mark-point-detail" >
                    <span>{adress}</span>
                </div>
            
        </div>
    );
}

export default Point;